import { ref, computed, watch } from "vue"

export const setupWordTooltip = ({
  isShowExtractedWords,
  isForceShowHighlightBlocks,
  seeSourceAttributeSlug,
  containerState,
  currentPageState,
  scalingState
}) => {
  let element = null
  const boundingBox = ref(undefined)

  const isShow = computed(() => {
    return (
      (!!isShowExtractedWords.value ||
        !!isForceShowHighlightBlocks.value ||
        typeof seeSourceAttributeSlug !== "undefined") &&
      !!containerState.element.value &&
      !!containerState.width.value &&
      !!containerState.height.value &&
      !!currentPageState.imageUrl.value &&
      !!currentPageState.positionalText.value &&
      !!currentPageState.width.value &&
      !!currentPageState.height.value &&
      !!boundingBox.value
    )
  })

  watch(
    [
      containerState.element,
      containerState.width,
      containerState.height,
      currentPageState.imageUrl,
      currentPageState.positionalText,
      currentPageState.width,
      currentPageState.height,
      scalingState.scale
    ],
    () => {
      boundingBox.value = undefined
    },
    { immediate: true }
  )

  watch(
    [isShow, boundingBox],
    ([isShow, boundingBox], [_oldIsShow, oldBoundingBox]) => {
      if (!containerState.element.value) return

      if (!isShow || !boundingBox) {
        if (element) {
          containerState.element.value.removeChild(element)
          element = null
        }
        return
      }

      if (oldBoundingBox && boundingBox.id !== oldBoundingBox.id) {
        if (element) {
          containerState.element.value.removeChild(element)
          element = null
        }
      }

      element = document.createElement("div")
      element.textContent = boundingBox.word
      element.style.display = "block"
      element.style.position = "absolute"
      element.style.maxWidth = "80%"
      element.style.color = "white"
      element.style.backgroundColor = boundingBox.color
      element.style.padding = "4px 8px"
      element.style.borderRadius = "4px"

      containerState.element.value.appendChild(element)

      const tooltipWidth = element.getBoundingClientRect().width
      const tooltipHeight = element.getBoundingClientRect().height

      element.style.width = `${tooltipWidth}px`
      element.style.height = `${tooltipHeight}px`

      const { top, left } = (() => {
        const boxTop = boundingBox.boundingBox[0].y
        const boxLeft = boundingBox.boundingBox[0].x

        const containerWidth = containerState.width.value
        const containerHeight = containerState.height.value

        const containerScrollTop = containerState.element.value.scrollTop
        const containerScrollLeft = containerState.element.value.scrollLeft

        const pageWidth = currentPageState.width.value * scalingState.scale.value
        const pageLeftMargin = pageWidth < containerWidth ? (containerWidth - pageWidth) / 2 : 0

        let top = boxTop * scalingState.scale.value - 12
        if (top - containerScrollTop < 0) {
          top = containerScrollTop
        } else if (top + tooltipHeight > containerHeight + containerScrollTop) {
          top = containerHeight + containerScrollTop - tooltipHeight
        }

        let left = boxLeft * scalingState.scale.value + 24 + pageLeftMargin
        if (left - containerScrollLeft < 0) {
          left = containerScrollLeft
        } else if (left + tooltipWidth > containerWidth + containerScrollLeft) {
          left = containerWidth + containerScrollLeft - tooltipWidth
        }

        return { top, left }
      })()

      element.style.top = `${top}px`
      element.style.left = `${left}px`
    },
    { immediate: true }
  )

  return {
    boundingBox
  }
}
